import { InquiryCategoryEnum } from '../interfaces/filters.interface';

const INQUIRY_CATEGORY = new Map([
  [InquiryCategoryEnum.AccessParking, 'アクセス・駐車場'],
  [InquiryCategoryEnum.AccommodationsGuestRooms, '宿泊・客室'],
  [InquiryCategoryEnum.DiningRestaurants, '食事・レストラン'],
  [InquiryCategoryEnum.FacilitiesEquipment, '館内施設・設備'],
  [InquiryCategoryEnum.Bathing, '入浴・風呂'],
  [InquiryCategoryEnum.BringingChildren, '子供連れでの利用'],
  [InquiryCategoryEnum.Activities, 'アクティビティ'],
  [InquiryCategoryEnum.Pets, 'ペット'],
  [InquiryCategoryEnum.NeighborhoodInformation, '周辺情報'],
  [InquiryCategoryEnum.ReservationChange, '予約の変更'],
  [InquiryCategoryEnum.Other, 'その他'],
]);

export function getInquiryCategoryName(
  inquiryCategory: InquiryCategoryEnum,
): string {
  return INQUIRY_CATEGORY.get(inquiryCategory) || '';
}

export function getInquiryCategories() {
  return INQUIRY_CATEGORY;
}
